import script from "./ManageRecruitersView.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageRecruitersView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__